import {
  useReadContract,
  useWatchTransactionReceipt,
  useWriteContract
} from "@buidlerlabs/hashgraph-react-wallets";
import { ContractId } from "headstarter-crypto/hashgraph-sdk";
import FunctionForm from "./FunctionForm";
import { CHAINS } from "../../utils/constants";

const LiveContractExecutor = ({ contractId, abi, contractInterface }) => {
  const { readContract } = useReadContract({ chain: CHAINS[0] });
  const { writeContract } = useWriteContract();
  const { watch } = useWatchTransactionReceipt({ abi });

  const handleExecute = async (isReadable, functionName, args, metaArgs) => {
    const jsonABI = JSON.parse(contractInterface.format("json"));

    return new Promise(async (resolve, reject) => {
      if (isReadable) {
        const response = await readContract({
          address: `0x${ContractId.fromString(contractId).toSolidityAddress()}`,
          abi: jsonABI,
          functionName,
          args
        });

        resolve(response);
        return;
      }

      const transactionIdOrHash = await writeContract({
        contractId: ContractId.fromString(contractId),
        abi: jsonABI,
        functionName,
        args,
        metaArgs
      });

      return await watch(transactionIdOrHash, {
        onSuccess: (transaction) => {
          resolve(transaction);
        },
        onError: (_, error) => {
          reject(error);
        }
      });
    });
  };

  const displayedContractFunctions = contractInterface
    ? Object.entries(contractInterface.functions).filter(
        (fn) => fn[1]["type"] === "function"
      )
    : [];

  return displayedContractFunctions.map((contractFuncInfo) => {
    const functionDefinition = contractFuncInfo[0];
    const functionFragment = contractFuncInfo[1];

    return (
      <FunctionForm
        key={"function-form-" + functionDefinition}
        functionInfo={functionFragment}
        execute={handleExecute}
      />
    );
  });
};

export default LiveContractExecutor;
